import { useContext, useEffect } from 'react'
import { SpineContext } from './SpineContext'
import type { SpineSpec } from './SpineContext'

export function useSpine(): SpineSpec | null {
  return useContext(SpineContext).spec
}

/** Declare the page's place on the spine; cleared when the page unmounts. */
export function useSetSpine(spec: SpineSpec | null): void {
  const { setSpec } = useContext(SpineContext)
  const key = JSON.stringify(spec)
  useEffect(() => {
    setSpec(spec ? (JSON.parse(key) as SpineSpec) : null)
    return () => setSpec(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, setSpec])
}
